import { Tooltip as MuiTooltip, TooltipProps, styled } from "@mui/material";

export const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip arrow {...props} componentsProps={{ tooltip: { className } }} />
))(({ theme }) => ({
  "& .MuiTooltip-arrow": {
    color: theme.palette.secondary.main,
  },
  "&.MuiTooltip-tooltip": {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 4,
  },
}));

export default Tooltip;
